<!--  -->
<template>
    <div class='About_ISFAL'>
        <div class="title_box">
            <img src="../../assets/images/isfal/10016.jpg" alt="">
        </div>
        <div class="cen_box">
            <div class="cen_box_box">
                <h1>Contact Us</h1>
                <div class="Contact_Us">
                    <p class="title">If you have some information to inquiry or some practice would like sharing, please
                        send us message as the format list below:</p>
                    <div class="title_1">
                        <p class="title_1_1">Send a Message：</p>
                        <p class="title_1_2">Your name and email which we can contact you directly</p>
                    </div>
                </div>
                <el-form ref="form" :model="form" label-width="80px" style="padding-bottom: 150px;">
                    <div style="display: flex;">
                        <el-form-item label="Name" style="margin-right:50px;">
                            <el-input style="width:427px;" v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="Email">
                            <el-input style="width:427px;" v-model="form.email"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="Message">
                        <el-input style="width:985px;" type="textarea" :rows="8"
                            placeholder="Message will be displayed after confirmation" v-model="form.remark">
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">Submit</el-button>
                    </el-form-item>
                </el-form>


            </div>
        </div>
        <el-dialog title="" :visible.sync="dialogVisible" width="35%" >
         <div style="display:flex">
            <p style="font-size:30px;color:#43B528;" class="el-icon-circle-check"></p>
            <p style="    font-size: 20px;
    margin: 2px 0 0 5px;">Succeeded,please wait for r...</p>
         </div>
        </el-dialog>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: '',
        data() {
            //这里存放数据
            return {
                form: {
                    name: "",
                    email: "",
                    remark: ""
                },
                dialogVisible:false ,
            }
        },
        components: {},

        //方法集合
        methods: {
            onSubmit() {
                if (this.form.remark == '') {
                    this.$message('Send a Message：');
                } else {
                    this.feedbackreceive()
                }
            },
            feedbackreceive() {
                var _this = this;
                _this.$api.feedbackreceive(this.form).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        if (res.data == 1) {
                          this.dialogVisible=true
                            setTimeout(function () {
                                window.location.reload()
                            }, 2000);
                        }
                        // window.location.reload()
                    } else {
                        // _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    // _this.$message.error(error.msg);
                });
            },
        },
        created() {

        },
        mounted() {

        }
    }
</script>
<style scoped lang="less">
    .About_ISFAL {
        background: #fff;
    }
</style>